module.exports = __webpack_public_path__ + "img/thumbnail_000.77d17936.png";